import { cardImageSources, type GenericCharacter } from './types'

export const genericFrankenstein: GenericCharacter = {
  id: 'generic-frankenstein',
  enabled: true,
  order: 6,
  displayName: 'Fran',
  icon: '🧟',
  imageSources: cardImageSources('generic-frankenstein'),
}
